import { render, staticRenderFns } from "./SuccessSendEmail.vue?vue&type=template&id=fee4d64e&"
import script from "./SuccessSendEmail.vue?vue&type=script&lang=js&"
export * from "./SuccessSendEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports